import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { PostDataWithToken } from '../../constants/ApiHelper'
import { useNavigate } from 'react-router'
import Loader from '../../common/Loader'

import { useCookies } from 'react-cookie'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchMmvData } from '../../store/actions/userActions'
import Layout from '../../common/Layout'

const AddMM = () => {
  const dispatch = useDispatch()
  // const loginUrl = 'https://api.insurefast.in/api/v1/'
   const loginUrl = 'https://uatmasterapi.flaskitsolutions.com'
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ mode: 'onBlur' })
  const navigate = useNavigate()
  const [showPass, setShowPass] = useState(false)
  const [loading, setLoading] = useState(false)
  const cookie = useCookies()
  const [cookies, setCookie, removeCookie] = useCookies([
    'userName',
    'token',
    'role'
  ])
  useEffect(() => {
    dispatchMmvData('apiUrl', loginUrl)
  })

  const handleCreate = data => {
    setLoading(true)
    PostDataWithToken('/login-panel/create-login', data)
      .then(res => {
        if (res && res.success) {
          const { token, username, role } = res.data
          setCookie('token', token, { path: '/' })
          setCookie('username', username, { path: '/' })
          setCookie(role, role, { path: '/' })
        } else {
          console.error('Login failed:', res)
        }
      })
      .catch(error => {
        console.error('Login error:', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <div><Layout>
           <div className='card-body mt-7'>
                              <form role='form' onSubmit={handleSubmit(handleCreate)}>
                                <label>Full Name</label>
                                <div className='mb-3'>
                                  <input
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Full Name'
                                    aria-label='Username'
                                    aria-describedby='email-addon'
                                    id='username'
                                    name='username'
                                    {...register('username', {
                                      required: 'Username is required'
                                    })}
                                  />
                                  <span>
                                    <p className='text-danger error-msg'>
                                      {errors.username && errors?.username?.message}
                                    </p>
                                  </span>
                                </div>
                                <label>Email</label>
                                <div className='mb-3'>
                                  <input
                                    type='email'
                                    className='form-control'
                                    placeholder='Enter Email Id'
                                    aria-label='email'
                                    aria-describedby='email-addon'
                                    id='email'
                                    name='email'
                                    {...register('email', {
                                      required: 'Email is required'
                                    })}
                                  />
                                  <span>
                                    <p className='text-danger error-msg'>
                                      {errors.email && errors?.email?.message}
                                    </p>
                                  </span>
                                </div>
                                <label>Mobile</label>
                                <div className='mb-3'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    placeholder='Enter Mobile Number'
                                    aria-label='mobileNo'
                                    aria-describedby='email-addon'
                                    id='mobileNo'
                                    name='mobileNo'
                                    {...register('mobileNo', {
                                      required: 'Mobile No is required'
                                    })}
                                  />
                                  <span>
                                    <p className='text-danger error-msg'>
                                      {errors.mobileNo && errors?.mobileNo?.message}
                                    </p>
                                  </span>
                                </div>
        
                                <div className='col-xl-12 col-lg-3 col-md-6 col-12'>
                                  <label>Add Role</label>
                                  <div className='mb-3'>
                                    <select
                                      className='form-control'
                                      id='role'
                                      name='role'
                                      {...register('role', {
                                        required: 'Role is required'
                                      })}
                                    >
                                      <option key='' value=''>
                                        Select Role
                                      </option>
                                      <option
                                        key='mappingManager'
                                        value='mappingManager'
                                      >
                                        Mapping Mananger
                                      </option>
                                    </select>
                                  </div>
                                  <span>
                                    <p className='text-danger error-msg'>
                                      {errors.role && errors?.role?.message}
                                    </p>
                                  </span>
                                </div>
                                <div>
                                  <div className='text-center'>
                                    <button
                                      type='submit'
                                      className='btn bg-gradient-info w-100 mt-4 mb-0'
                                    >
                                      {loading ? <Loader /> : 'Sign In'}
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
        </Layout>
        </div>
  )
}

export default AddMM